import React from "react";
import { FormControl, MenuItem, Select, Stack, Switch, Typography } from "@mui/material";
import { TipoMaterialN1, TIPO_MATERIAL_LABELS, ITipoMaterialPermitido } from "../types/materiaisN1.types";

interface BarraControlesProps {
  tiposPermitidos: ITipoMaterialPermitido[];
  tipoMaterialSelecionado: TipoMaterialN1 | null;
  modoEdicaoAtivo: boolean;
  apenasConsulta?: boolean; // FASE 05 — 2ª validação/PO 2026-07-24 (B2): oculta o toggle.
  // FASE 05 — Ajustes 25/08 (item 1 / F05A-P1): na página de Acabamentos não há escolha de
  // tipo — o seletor "Listagem de" some e a página fica fixa em acabamentos.
  ocultarSeletorTipo?: boolean;
  onTipoMaterialChange: (tipo: TipoMaterialN1) => void;
  onModoEdicaoChange: (ativo: boolean) => void;
  children?: React.ReactNode; // Botões de ação (Homologar, Liberar CEM, etc.)
}

export const BarraControles: React.FC<BarraControlesProps> = ({
  tiposPermitidos,
  tipoMaterialSelecionado,
  modoEdicaoAtivo,
  apenasConsulta = false,
  ocultarSeletorTipo = false,
  onTipoMaterialChange,
  onModoEdicaoChange,
  children,
}) => {
  return (
    <Stack direction="row" spacing={4} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
      {/* Lado esquerdo: Dropdown "Listagem de" + Toggle "Modo edição" */}
      <Stack direction="row" spacing={4} alignItems="center">
        {/* Dropdown "Listagem de" — ausente na página de Acabamentos (F05A-P1). */}
        {!ocultarSeletorTipo && (
        <Stack direction="row" alignItems="center" spacing={2}>
          <Typography 
            variant="body1" 
            sx={{ 
              color: "#666", 
              fontWeight: 400,
              whiteSpace: "nowrap",
            }}
          >
            Listagem de
          </Typography>
          <FormControl sx={{ minWidth: 200 }}>
            <Select
              id="listagem-de-select"
              value={tipoMaterialSelecionado || ""}
              onChange={(e) => onTipoMaterialChange(e.target.value as TipoMaterialN1)}
              displayEmpty
              sx={{ 
                backgroundColor: "#e0e0e0",
                borderRadius: 1,
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                "&.Mui-focused": {
                  backgroundColor: "#e0e0e0",
                },
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
                "& .MuiSelect-select": {
                  py: 1.25,
                  fontWeight: 500,
                },
                "& .MuiSvgIcon-root": {
                  color: "#616161",
                },
              }}
            >
              {tiposPermitidos.map((tipo) => (
                <MenuItem key={tipo.idTipoMaterial} value={tipo.tipoMaterial}>
                  {TIPO_MATERIAL_LABELS[tipo.tipoMaterial]}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        )}

        {/* Toggle "Modo edição" — oculto em empresa "apenas consulta" (B2). */}
        {!apenasConsulta && (
          <Stack direction="row" alignItems="center" spacing={1}>
            <Switch
              checked={modoEdicaoAtivo}
              onChange={(e) => onModoEdicaoChange(e.target.checked)}
              color="primary"
              sx={{
                "& .MuiSwitch-switchBase.Mui-checked": {
                  color: "#3C90AD",
                },
                "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                  backgroundColor: "#3C90AD",
                },
              }}
            />
            <Typography variant="body1" sx={{ fontWeight: 500, color: "#333" }}>
              Modo edição
            </Typography>
          </Stack>
        )}
      </Stack>

      {/* Lado direito: Botões de ação (Homologar, Liberar CEM, etc.) */}
      {children && (
        <Stack direction="row" spacing={1} alignItems="center">
          {children}
        </Stack>
      )}
    </Stack>
  );
};
